import { BaseDataTransferObject } from '../base-data-transfer-object';
import { BillTo } from '../billing/bill-type';
import { ZipCode } from '../common';

export class Client extends BaseDataTransferObject {
    public code!: string;
    public name!: string;
    public address!: string;
    public zipCode!: ZipCode;
    public unitsCount!: number;
    public defaultBillTo!: BillTo;
    public webAccess: boolean = true;
}

export class ClientWithExtras extends Client {
    public phone!: string;
    public fax!: string;
    public email!: string;
}
